"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const Utils_1 = require("../../../../utils/Utils");
const fa_1 = require("react-icons/fa");
function SuggestionDetailsModal({ show, handleClose, item }) {
    const [copied, setCopied] = (0, react_1.useState)(false);
    const handleCopy = (e, text) => __awaiter(this, void 0, void 0, function* () {
        e.stopPropagation();
        try {
            yield navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
        catch (error) {
            console.error("Erreur lors de la copie :", error);
        }
    });
    return (react_1.default.createElement(Modal_1.default, { show: show, onHide: handleClose, className: "custom__modal", size: "lg" },
        react_1.default.createElement(Modal_1.default.Header, { className: "modal-header-wrapper", closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, { className: "modal-title-custom" },
                (item === null || item === void 0 ? void 0 : item.type) === "suggestion" ? "Suggestion" : "Réclamation",
                " de ", item === null || item === void 0 ? void 0 :
                item.fullname)),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "custom-wrapper" },
                react_1.default.createElement("div", { className: "form-content" },
                    react_1.default.createElement("div", { className: "row infos-row" },
                        react_1.default.createElement("div", { className: "col-12 mb-5 d-flex d-flex align-items-center justify-content-between custom-wrapper" },
                            react_1.default.createElement("label", { htmlFor: "", className: "add-notifs-modal-label" }, "N\u00B0 Carte Rapido"),
                            react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                                react_1.default.createElement("span", null, (item === null || item === void 0 ? void 0 : item.card_number) ? item.card_number : "Non renseigné"),
                                react_1.default.createElement("span", { onClick: (e) => handleCopy(e, item === null || item === void 0 ? void 0 : item.card_number), style: { cursor: "pointer" }, title: "Copier", className: copied ? "text-success" : "" }, copied ? react_1.default.createElement(fa_1.FaCheck, { size: 14 }) : react_1.default.createElement(fa_1.FaRegCopy, { size: 14 })),
                                copied && (react_1.default.createElement("small", { className: "text-success" }, "Copi\u00E9 avec succ\u00E8s")))),
                        react_1.default.createElement("div", { className: "col-12 mb-5 d-flex d-flex align-items-center justify-content-between custom-wrapper" },
                            react_1.default.createElement("label", { htmlFor: "", className: "add-notifs-modal-label" }, "N\u00B0 de t\u00E9l\u00E9phone"),
                            react_1.default.createElement("div", null, (item === null || item === void 0 ? void 0 : item.phone) ? item.phone : "Non renseigné")),
                        react_1.default.createElement("div", { className: "col-12 mb-5 custom-wrapper" },
                            react_1.default.createElement("label", { htmlFor: "", className: "add-notifs-modal-label mb-2" }, "Contenu du message"),
                            react_1.default.createElement("div", { className: "suggestion-message", dangerouslySetInnerHTML: (0, Utils_1.createMarkup)(item === null || item === void 0 ? void 0 : item.comment) }),
                            react_1.default.createElement("div", { style: { padding: '7rem 0' } }))))))));
}
exports.default = SuggestionDetailsModal;
